<template>
  <v-layout>
    <v-row>
      <v-col class="py-0 my-1">
        <v-card width="100%">
          <div>
            <span v-html="title"></span>
          </div>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.schKH"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.schEN"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)ឡាតាំង"
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            hide-details
            v-model="info.schnewKH"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            hide-details
            v-model="info.schnewEN"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)ឡាតាំង"
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.Village_KH"
            label="ភូមិ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.Commune_KH"
            label="ឃុំ/សង្កាត់"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.DisName_KH"
            label="ក្រុង/ស្រុក/ខណ្ឌ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="info.ProName_KH"
            label="រាជធានី/ខេត្ត "
          >
          </v-text-field>

          <v-select
            class="px-1"
            v-model="data.loc"
            :items="loca"
            item-text="text"
            item-value="value"
            outline
            label="ទីតាំងសាលារៀន"
            hide-details
            @keypress.native="onSelect1($event)"
          >
          </v-select>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.tele_sch"
            label="លេខទូរស័ព្ទការិយាល័យរដ្ឋបាល"
          >
          </v-text-field>
          <v-select
            class="px-1"
            v-model="data.center_typ"
            :items="center_type"
            item-text="text"
            item-value="value"
            outline
            label="ប្រភេទមណ្ឌល"
            hide-details
            @keypress.native="onSelect5($event)"
          >
          </v-select>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.center_oth"
            label="ផ្សេងៗ"
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            type="number"
            v-model="data.distance_com"
            label="ចម្ងាយពីមណ្ឌលទៅសាលាឃុំ សង្កាត់"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            type="number"
            v-model="data.distance_dis"
            label="ចម្ងាយពីមណ្ឌលទៅសាលាក្រុង ស្រុក ខណ្ឌ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            type="number"
            v-model="data.distanec_pro"
            label="ចម្ងាយពីមណ្ឌលទៅសាលារាជធានី ខេត្ត"
          >
          </v-text-field>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { location } from "@/utils/ascf/commonConfig.js";
import { center_type } from "@/utils/priascf/comPreVariables.js";

export default {
  props: ["data", "info", "title"],
  data() {
    return {
      loca: location,
      center_type: center_type,
    };
  },
  methods: {
    onSelect1: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.loc = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect5: function (event) {
      // Type_care services
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        // 4 options
        this.data.center_typ = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>